import React from 'react'
import Markdown from 'react-markdown'
import './SingleService.scss'

export const SingleService = ({ name, details, icon }) => {
  return (
    <div className="SingleService">
      <div className="icon">
        <img src={icon} alt="" />
      </div>
      <div className="text">
        <div className="name">{name}</div>
        <div className="details">
          <Markdown source={details} />
        </div>
      </div>
    </div>
  )
}

export default SingleService
